import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, LoaderService } from '~services';

@Component({
  selector: 'app-auth-callback-view',
  template: ``,
  standalone: false,
})
export class AuthCallbackViewComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private authService: AuthService,
    private loaderService: LoaderService,
  ) {}

  async ngOnDestroy(): Promise<void> {
    this.loaderService.hide();
  }

  async ngOnInit(): Promise<void> {
    this.loaderService.show();
    const returnTo = await this.authService.handleCallback();
    this.router.navigateByUrl(returnTo);
  }
}
